:host {
  display: block;
}

.tree-view {
  background-color: var(--layer, $light);
}
